import Random from "~/ts/library/Random";

export const INSTANCE_ID = Random.uid(10);